import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { DataService } from './data.service';
import { UrlConstants } from './url-constants';
import { ConstantsService } from './constants.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public userData: any;
  public isFirstCall = true;
  defaultAvatar = this.constants.AVATAR_IMG;
  private profilePictureSource = new BehaviorSubject<string>(this.defaultAvatar);
  profilePicture$ = this.profilePictureSource.asObservable();
  constructor(
    private cacheService: CacheService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    public constants: ConstantsService
  ) { }
  async getUser(doDbCall) {
    if (this.isFirstCall && this.userData == undefined || doDbCall && this.userData == undefined) {
      this.isFirstCall = false;
      this.userData = await this.getUserDataFromDb()
      //  localstorage
      localStorage.setItem('watchedVideos', JSON.stringify(this.userData.watchedVideos));
      return this.userData
    }
    else {
      return this.userData
    }
  }
  async getUserDataFromDb() {
    if(this.userData == undefined ){
    let userName = (await this.cacheService.getAuthUser()).userName
    let user = (await this.cacheService.getAuthUser()).given_name
    const params = [
      { param: '{object}', value: 'getUser' },
      { param: '{id1}', value: userName },
      { param: '{id2}', value: user },
    ];
    return await this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params)).toPromise()
      .then(data => {
        user = data['Item'];
        this.userData = user;
        if(user.pictureUrl){
          this.updateProfilePicture(user.pictureUrl);
        }
        return user
      })
      .catch((error) => {
        let Key
        for (let items in localStorage) {
          let userData = items.includes("userData")
          if (userData) {
            Key = items
          }
        }
        const cognitoUser = JSON.parse(localStorage.getItem(Key))
        const UserAttributes = cognitoUser && cognitoUser.UserAttributes !== null ? cognitoUser.UserAttributes : '';
        let userArray = {}
        UserAttributes?.forEach(element => {
          let { Name, Value } = element
          userArray[Name] = Value
        });
        const params = [
          { param: '{object}', value: 'user' },
        ];
        const bodyObj = {
          "email": userArray["email"],
          "first_name": userArray["given_name"],
          "last_name": userArray["family_name"],
          "userName": userName
        }
        this.dataService.postData(this.urlConstants.getUri(this.urlConstants.createItem, params), JSON.stringify(bodyObj))
          .subscribe(res => {
            this.getUser(true)
            window.location.reload()
          })
      })
    } else{
      return this.userData;
    }
  }

  updateProfilePicture(newPictureUrl: string) {
    this.profilePictureSource.next(newPictureUrl);
  }
}
